import React, { useMemo } from 'react';
import ImpressionTimeline from '../../../../../../shared/designSystem/components/ImpressionTimeline';
import { getMobileOperatingSystem } from './utils';

// =============================================================================
// ClicksTimeLine (V1 Transactions) — facelifted off the local AntD
// `Timeline` + 3-column `Row/Col` chrome to the shared
// `<ImpressionTimeline/>` primitive. Click events normalize cleanly to the
// primitive's row shape:
//   CLICK_TIME      → impressionTime
//   CLICK_USERAGENT → impressionPublisherPlatform (via getMobileOperatingSystem)
//   ID_CLICK        → media (rendered as the descriptor row + tooltip)
// `impressionPublisher` shows "Click event" so the row reads as a click
// rather than an ad impression. `showMediaRow` exposes the click ID as
// the secondary text.
//
// Sorting is owned by the primitive (`sort="newest"`); the legacy
// useEffect+sort pre-step is dropped.
// =============================================================================

const normalizeClick = (click, i) => {
  const { CLICK_TIME, CLICK_USERAGENT, ID_CLICK } = click;
  const OS = CLICK_USERAGENT ? getMobileOperatingSystem(CLICK_USERAGENT) : 'Unknown';
  return {
    eventId: ID_CLICK || `click-${i}`,
    impressionTime: CLICK_TIME,
    impressionPublisher: 'Click event',
    impressionPublisherPlatform: OS,
    media: ID_CLICK ? `Click ID · ${ID_CLICK}` : '',
  };
};

const ClicksSubTable = ({ clicks = [] }) => {
  const normalized = useMemo(
    () => (clicks || []).map(normalizeClick),
    [clicks]
  );

  return (
    <ImpressionTimeline
      impressions={normalized}
      sort="newest"
      showMediaRow
      emptyText="No clicks recorded for this transaction."
    />
  );
};

export default ClicksSubTable;
